import script from "./InpsectionWizardProgressBar.vue?vue&type=script&setup=true&lang=js"
export * from "./InpsectionWizardProgressBar.vue?vue&type=script&setup=true&lang=js"

import "./InpsectionWizardProgressBar.vue?vue&type=style&index=0&id=0d9ab454&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0d9ab454"]])

export default __exports__